export const feedbackMessage = {
	data: '',
	count: '',
	title: 'Give Feedback',
	subtitle: 'How would you rate our services?',
	messageTitle: 'Any thoughts you’d like to share?',
	messagePlaceholder: 'Please leave your feedback (max. 20 words)',
};
